module.exports = __webpack_public_path__ + "static/media/ad-blocker.692fed95.svg";